(function (Drupal, Swiper) {
  Drupal.behaviors.ourHistorySlider = {
    attach(context) {
      once('ourHistorySlider', '.our-history .swiper', context).forEach(function (element) {
        new Swiper(element, {
          spaceBetween: 200,
          slidesPerView: 1,
          slidesPerGroup: 1,
          pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
          },
          navigation: {
            nextEl: ".btn-next",
            prevEl: ".btn-prev",
          },
        });
      });
    },
  };
})(Drupal, Swiper);
